import { PDFDownloadLink } from "@react-pdf/renderer";
import BookingPDF from "./BookingPDF";
import DownloadIcon from '@mui/icons-material/Download';
import Button from '@mui/material/Button';

const PDFDownloadButton = ({ workshops, userInfo, plannedBookings, morningLocation, eveningLocation }) => (
  <PDFDownloadLink
    document={<BookingPDF workshops={workshops} userInfo={userInfo} plannedBookings={plannedBookings} morningLocation={morningLocation} eveningLocation={eveningLocation} />}
    fileName={'Karjaaripaev_broneering_' + userInfo.first_name + '_' + userInfo.last_name + '.pdf'}
    style={{
      color: "#fff",
      textDecoration: "none",
    }}
  >
    {({ loading }) => (
      <Button
        variant="contained"
        color="primary"
        startIcon={<DownloadIcon />}
        disabled={loading}
      >
        {loading ? "Genereerin PDF faili" : "Lae broneeringud alla PDF kujul"}
      </Button>
    )}
  </PDFDownloadLink>
);

export default PDFDownloadButton;